exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-notification[data-v-f1f098ac] {\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px #efefef solid;\n}", ""]);

// exports
